import React from 'react';
import PropTypes from 'prop-types';
import Row from './Row';
import { Mandates, Table, PartyTitle, PartyMandates, Info } from './styles'
import Title from '../../Symbols/Title';
import WithMore from '../WithMore';

const declensions = {
	'1': 'zastupitel',
	'2': 'zastupitelé',
	'3': 'zastupitelé',
	'4': 'zastupitelé',
	'default': 'zastupitelů'
}

function SimpleMandates({
	title,
	items = []
}) {
	return <Mandates>
		<Title>{title}</Title>
		{items.map((item, index) => <Table key={index}>
			<thead>
				<tr>
					<PartyTitle colSpan="3">
						{item.name} - <PartyMandates>
							{item.mandates.length} {declensions[item.mandates.length] || declensions.default}
						</PartyMandates>
					</PartyTitle>
				</tr>
			</thead>
			<tbody>
				{item.mandates.map((mandate, position) => <Row
					key={mandate.id}
					position={position + 1}
					name={mandate.name}
					lastName={mandate.lastName}
					votes={mandate.votes}
				/>)}
			</tbody>
		</Table>)}
		<Info>Řazeno podle pořadí zvolení</Info>
	</Mandates>
}

SimpleMandates.propTypes = {
	title: PropTypes.string.isRequired,
	items: PropTypes.arrayOf(PropTypes.object).isRequired,
	opened: PropTypes.bool
};

export default WithMore(SimpleMandates, { length: 7 });
